import { gql } from "@apollo/client";

export const AddEmployeeMutation = gql `
mutation($input: EmployeeInput!){
    addEmployee(input: $input) {
      response
      message
    }
}
`;

export const RestoreEmployeeMutation = gql `
mutation($employeeId: String!){
    restoreEmployee(employeeId: $employeeId) {
      response
      message
    }
}
`;

export const updateEmployeeMutation = gql `
mutation($input: EmployeeUpdateInput!){
  updateEmployee(input: $input) {
    response
  }
}
`;

export const updateBulkEmployeeMutation = gql `
mutation($input: BulkEmployeeUpdateInput!){
  updateBulkEmployee(input: $input) {
    response
  }
}
`;

export const updateBulkEmployeeRateMutation = gql`
mutation($input: BulkEmployeeUpdateInput!){
  updateBulkEmployeeRate(input: $input) {
    message
    response
  }
}`;

export const ApproveThirdPartyEmployeeMutation = gql`
mutation($input: ApproveThirdPartyEmployeeInput!){
  approveThirdPartyEmployee(input: $input) {
    message
    response
  }
}`;

export const RejectThirdPartyEmployeeMutation = gql`
mutation($input: RejectThirdPartyEmployeeInput!){
  rejectThirdPartyEmployee(input: $input) {
    message
    response
  }
}`;